module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1265.faf0111f.jpg";